import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import GroupCard from "@/components/base/GroupCard";
import { groups } from "@/mocks/groups";

export default function FeaturedGroups() {
  const featured = groups.filter((g) => g.featured).slice(0, 6);

  return (
    <section className="w-full bg-background-50 px-4 py-14 md:px-6 md:py-20" aria-label="热门群组推荐">
      <div className="mx-auto max-w-6xl">
        <div className="flex flex-col gap-5 md:flex-row md:items-end md:justify-between">
          <SectionHeading
            eyebrow="本周推荐"
            title="这周被瓜友反复提到的好群"
            desc="下面这些群近期活跃稳定、管理到位，是我们综合成员反馈后给出的本周推荐。加入前请先阅读各自的入群提示。"
          />
          <Link
            to="/ranking"
            className="inline-flex shrink-0 items-center gap-1.5 whitespace-nowrap font-label text-sm text-primary-600 transition-colors hover:text-primary-700"
          >
            查看完整排行
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3">
          {featured.map((group) => (
            <GroupCard key={group.id} group={group} />
          ))}
        </div>
      </div>
    </section>
  );
}